import { format } from 'date-fns';
import { Card, CardContent } from '@/components/ui/card';
import type { LeadNote } from '../types';

interface NoteCardProps {
  note: LeadNote;
}

/**
 * Display a single note in a card format
 * Shows note text and metadata (author and timestamp)
 */
export function NoteCard({ note }: NoteCardProps) {
  const formattedDate = format(new Date(note.createdAt), 'MMM d, yyyy \'at\' h:mm a');

  return (
    <Card>
      <CardContent className="pt-4">
        <p className="text-base whitespace-pre-wrap mb-2">{note.noteText}</p>
        <p className="text-sm text-gray-500">
          Added by {note.createdByName} on {formattedDate}
        </p>
      </CardContent>
    </Card>
  );
}
